import { Component, OnInit } from '@angular/core';
import { Role } from 'src/app/models/role';
import { Ability } from 'src/app/models/ability';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AbilityService } from 'src/app/services/ability.service';
import { RoleService } from 'src/app/services/role.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-ability-to-role',
  templateUrl: './ability-to-role.component.html',
  styleUrls: ['./ability-to-role.component.css']
})
export class AbilityToRoleComponent implements OnInit {

  loading:boolean = false;
  roles:Role[] = [];
  role:Role = new Role();
  abilities:Ability[] = [];
  abilitiesFromRole:Ability[] = [];
  ability:Ability = new Ability();

  constructor(private roleServ:RoleService, private abilityServ:AbilityService, private authServ:PermissionsService, private modalService:NgbModal) { }

  ngOnInit() {
    this.loading = true;
    this.roleServ.getRoles().then(roles => {
      this.roles = roles;
      this.loading = false;
    });
    this.abilityServ.getAbilities().then(abilities => this.abilities = abilities);
  }

  selectR(role:Role) {
    this.role = role;
    this.loading = true;
    this.authServ.loadRoleAbilities(role).then(abilities => {
      this.abilitiesFromRole = abilities;
      this.loading = false;
    });
  }

  select(addModal, role) {
    this.selectR(role);
    this.modalService.open(addModal, { size: 'lg' });
  }

  store(event) {
    event.preventDefault();
    
    this.loading = true;
    this.authServ.addAbilityToRole(this.ability, this.role).then(resp => {
      this.loading = false;
    });
  }

}
